module.exports = __webpack_public_path__ + "static/media/qr-code-generator-logo.fb03701f.png";